var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block__visual"},[_c('div',{staticClass:"mock lift-hover",style:(_vm.mockStyle)},[(_vm.displayImage)?_c('img',{staticClass:"mock__img-fit",attrs:{"src":_vm.displayImage,"alt":_vm.altText},on:{"load":_vm.onImageLoad}}):_c('div',{staticClass:"mock__placeholder"},[_vm._v("请在后台上传产品配图")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }